import axios from '../../API/config';


export const createException = async (exceptionData) => {
  try {
    const response = await axios.post('/exceptions', exceptionData);
    return response.data;
  } catch (error) {
    console.error("Error creating exception:", error);
    throw error;
  }
};

export const getAllExceptions = async (page = 1, perPage = 15, filters = {}) => {
  try {
    const params = new URLSearchParams({
      page,
      per_page: perPage,
    });

    if (filters.status && filters.status !== 'all') params.append('status', filters.status);
    if (filters.council && filters.council !== 'all') params.append('council_name', filters.council);
    if (filters.reportType && filters.reportType !== 'all') params.append('report_type', filters.reportType);

    const response = await axios.get(`/exceptions?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching exceptions:", error);
    throw error;
  }
};

export const getExceptionFilters = async () => {
  try {
    const response = await axios.get('/exceptions/filters');
    return response.data;
  } catch (error) {
    console.error("Error fetching exception filters:", error);
    throw error;
  }
};

export const getAllPendingExceptions = async () => {
  try {
    const response = await axios.get('/exceptions/pending');
    return response.data;
  } catch (error) {
    console.error("Error fetching pending exceptions:", error);
    throw error;
  }
};

export const updateException = async (id) => {
  try {
    const response = await axios.put(`/exceptions/${id}/resolve`);
    return response.data;
  } catch (error) {
    console.error("Error updating exception:", error);
    throw error;
  }
};

export const reprocessPreprocessingException = async (id) => {
  try {
    const response = await axios.post(`/exceptions/${id}/reprocess`);
    return response.data;
  } catch (error) {
    console.error("Error reprocessing exception:", error);
    throw error;
  }
};

export const createProject = async (projectData) => {
    try {
      const response = await axios.post('/projects', projectData);
      return response.data;
    } catch (error) {
      console.error("Error creating project:", error);
      throw error;
    }
  };

  export const getAllProjects = async () => {
    try {
      const response = await axios.get('/projects');
      return response.data.data;
    } catch (error) {
      console.error("Error creating project:", error);
      throw error;
    }
  };
  
  export const updateProjectAliasFor = async (id, aliasForData) => {
    try {
      const response = await axios.put(`/projects/${id}`, aliasForData);
      return response.data;
    } catch (error) {
      console.error("Error updating project alias_for:", error);
      throw error;
    }
  };

export const createCouncil = async (councilData) => {
  try {
    const response = await axios.post('/councils', councilData);
    return response.data;
  } catch (error) {
    console.error("Error creating council:", error);
    throw error;
  }
};

export const getAllCouncils = async () => {
  try {
    // Request only minimal fields for alias selection to improve performance
    const response = await axios.get('/councils', { params: { fields: 'id,name' } });
    return response.data;
  } catch (error) {
    console.error("Error creating council:", error);
    throw error;
  }
};

export const updateCouncilAliasFor = async (id, aliasForData) => {
  try {
    const response = await axios.put(`/councils/${id}/alias-for`, aliasForData);
    return response.data;
  } catch (error) {
    console.error("Error updating council alias_for:", error);
    throw error;
  }
};

export const createUser = async (userData) => {
  try {
    const response = await axios.post('/users', userData);
    return response.data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};

export const createProcuringEntity = async (procuringEntityData) => {
  try {
    const response = await axios.post('/procuring_entities', procuringEntityData);
    return response.data;
  } catch (error) {
    console.error("Error creating procuring entity v2:", error);
    throw error;
  }
};

export const createPackage = async (packageData) => {
  try {
    const response = await axios.post('/procuring_entity_packages', packageData);
    return response.data;
  } catch (error) {
    console.error("Error creating package:", error);
    throw error;
  }
};

export const getAllPackages = async ({procring_entity_id}) => {
  try {     
    const response = await axios.get(`/procuring_entity_packages?filter[procuring_entity_id]=${procring_entity_id}`);
    return response.data.data;
  } catch (error) {
    console.error("Error creating package:", error);
    throw error;
  }
};

export const updatePackageAliasFor = async (id, aliasForData) => {
  try {
    const response = await axios.put(`/procuring_entity_packages/${id}`, aliasForData);
    return response.data;
  } catch (error) {
    console.error("Error updating package alias_for:", error);
    throw error;
  }
};

export const createContractor = async (contractorData) => {
  try {
    const response = await axios.post('/contractor', contractorData);
    return response.data;
  } catch (error) {
    console.error("Error creating contractor:", error);
    throw error;
  }
};

export const getAllContractors = async () => {
  try {
    const response = await axios.get('/contractor');
    return response.data;
  } catch (error) {
    console.error("Error creating contractor:", error);
    throw error;
  }
};

export const updateContractorAliasFor = async (id, aliasForData) => {
  try {
    const response = await axios.put(`/contractor/${id}/alias-for`, aliasForData);
    return response.data;
  } catch (error) {
    console.error("Error updating contractor alias_for:", error);
    throw error;
  }
};

export const createFinancier = async (financierData) => {
  try {
    const response = await axios.post('/financiers', financierData);
    return response.data;
  } catch (error) {
    console.error("Error creating financier:", error);
    throw error;
  }
};

export const createFinancierAlias = async (financierAliasData) => {
  try {
    const response = await axios.post('/financiers/create-alias', financierAliasData);
    return response.data;
  } catch (error) {
    console.error("Error creating financier alias:", error);
    throw error;
  }
};

export const getAllFinanciers = async () => {
  try {
    const response = await axios.get('/financiers');
    return response.data;
  } catch (error) {
    console.error("Error fetching financiers:", error);
    throw error;
  }
};

export const createSubProject = async (subProjectData) => {
  try {
    const response = await axios.post('/sub_project', subProjectData);
    return response.data;
  } catch (error) {
    console.error("Error creating sub-project:", error);
    throw error;
  }
};

export const getAllSubProjects = async (package_id) => {
  try {

    const response = await axios.get(`/sub_project?filters[procuring_entity_package_id]=${package_id}`);
    return response.data;
  } catch (error) {
    console.error("Error creating sub-project:", error);
    throw error;
  }
};

export const updateSubProjectAliasFor = async (id, aliasForData) => {
  try {
    const response = await axios.put(`/sub_project/${id}/alias-for`, aliasForData);
    return response.data;
  } catch (error) {
    console.error("Error updating sub-project alias_for:", error);
    throw error;
  }
};


export const createSubProjectType = async (subProjectTypeData) => {
  try {
    const response = await axios.post('/sub_project_types', subProjectTypeData);
    return response.data;
  } catch (error) {
    console.error('Error posting sub project type:', error);
    throw error;
  }
};

export const createProjectComponent = async (projectComponentData) => {
  try {
    const response = await axios.post('/project_components', projectComponentData);
    return response.data;
  } catch (error) {
    console.error('Error creating project component:', error);
    throw error;
  }
};

export const getAllProjectComponents = async (projectId) => {
  try {
    const params = projectId ? `?filter[project_id]=${projectId}` : '';
    const response = await axios.get(`/project_components${params}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching project components:', error);
    throw error;
  }
};

export const getAllSubProjectTypes = async () => {
  try {
    const response = await axios.get('/sub_project_types');
    return response.data;
  } catch (error) {
    console.error('Error fetching sub project types:', error);
    throw error;
  }
};

export const createDistrict = async (districtData) => {
  try {
    const response = await axios.post('/districts', districtData);
    return response.data;
  } catch (error) {
    console.error("Error creating district:", error);
    throw error;
  }
};

export const getAllDistricts = async () => {
  try {
    const response = await axios.get('districts');
    return response.data;
  } catch (error) {
    console.error("Error fetching districts:", error);
    throw error;
  }
};

export const getAllRegions = async () => {
  try {
    const response = await axios.get('/locations/regions');
    return response.data;
  } catch (error) {
    console.error("Error fetching regions:", error);
    throw error;
  }
};

export const createGrievanceCategory = async (grievanceCategoryData) => {
  try {
    const response = await axios.post('/grievance-categories-list', grievanceCategoryData);
    return response.data;
  } catch (error) {
    console.error("Error creating grievance category:", error);
    throw error;
  }
};

export const getAllGrievanceCategories = async () => {
  try {
    const response = await axios.get('/grievance-categories-list');
    return response.data;
  } catch (error) {
    console.error("Error fetching grievance categories:", error);
    throw error;
  }
};

export const createGrievanceStatus = async (grievanceStatusData) => {
  try {
    const response = await axios.post('/grievance-statuses-list', grievanceStatusData);
    return response.data;
  } catch (error) {
    console.error("Error creating grievance status:", error);
    throw error;
  }
};

export const getAllGrievanceStatuses = async () => {
  try {
    const response = await axios.get('/grievance-statuses-list');
    return response.data;
  } catch (error) {
    console.error("Error fetching grievance statuses:", error);
    throw error;
  }
};

export const createCurrency = async (currencyData) => {
  try {
    const response = await axios.post('/currencies', currencyData);
    return response.data;
  } catch (error) {
    console.error("Error creating currency:", error);
    throw error;
  }
};

export const createCurrencyAlias = async (currencyAliasData) => {
  try {
    const response = await axios.post('/currencies/create-alias', currencyAliasData);
    return response.data;
  } catch (error) {
    console.error("Error creating currency alias:", error);
    throw error;
  }
};

export const getAllCurrencies = async () => {
  try {
    const response = await axios.get('/currencies');
    return response.data;
  } catch (error) {
    console.error("Error fetching currencies:", error);
    throw error;
  }
};

export const createPosition = async (positionData) => {
  try {
    const response = await axios.post('/positions', positionData);
    return response.data;
  } catch (error) {
    console.error("Error creating position:", error);
    throw error;
  }
};

export const createPositionAlias = async (positionAliasData) => {
  try {
    const response = await axios.post('/positions/create-alias', positionAliasData);
    return response.data;
  } catch (error) {
    console.error("Error creating position alias:", error);
    throw error;
  }
};

export const getAllPositions = async () => {
  try {
    const response = await axios.get('/positions');
    return response.data;
  } catch (error) {
    console.error("Error fetching positions:", error);
    throw error;
  }
};

export const createRapStatus = async (rapStatusData) => {
  try {
    const response = await axios.post('/rap-status-lists', rapStatusData);
    return response.data;
  } catch (error) {
    console.error("Error creating RAP status:", error);
    throw error;
  }
};

export const createRapStatusAlias = async (rapStatusAliasData) => {
  try {
    const response = await axios.post('/rap-status-lists/create-alias', rapStatusAliasData);
    return response.data;
  } catch (error) {
    console.error("Error creating RAP status alias:", error);
    throw error;
  }
};

export const getAllRapStatuses = async () => {
  try {
    const response = await axios.get('/rap-status-lists');
    return response.data;
  } catch (error) {
    console.error("Error fetching RAP statuses:", error);
    throw error;
  }
};

export const createVendorGender = async (vendorGenderData) => {
  try {
    const response = await axios.post('/vendors-by-gender-list', vendorGenderData);
    return response.data;
  } catch (error) {
    console.error("Error creating vendor gender:", error);
    throw error;
  }
};

export const createVendorGenderAlias = async (vendorGenderAliasData) => {
  try {
    const response = await axios.post('/vendors-by-gender-list/create-alias', vendorGenderAliasData);
    return response.data;
  } catch (error) {
    console.error("Error creating vendor gender alias:", error);
    throw error;
  }
};

export const getAllVendorGenders = async () => {
  try {
    const response = await axios.get('/vendors-by-gender-list');
    return response.data;
  } catch (error) {
    console.error("Error fetching vendor genders:", error);
    throw error;
  }
};

export const createVulnerability = async (vulnerabilityData) => {
  try {
    const response = await axios.post('/vulnerability-list', vulnerabilityData);
    return response.data;
  } catch (error) {
    console.error("Error creating vulnerability:", error);
    throw error;
  }
};

export const createVulnerabilityAlias = async (vulnerabilityAliasData) => {
  try {
    const response = await axios.post('/vulnerability-list/create-alias', vulnerabilityAliasData);
    return response.data;
  } catch (error) {
    console.error("Error creating vulnerability alias:", error);
    throw error;
  }
};

export const getAllVulnerabilities = async () => {
  try {
    const response = await axios.get('/vulnerability-list');
    return response.data;
  } catch (error) {
    console.error("Error fetching vulnerabilities:", error);
    throw error;
  }
};

export const createVendorCategory = async (vendorCategoryData) => {
  try {
    const response = await axios.post('/categories-of-vendor-list', vendorCategoryData);
    return response.data;
  } catch (error) {
    console.error("Error creating vendor category:", error);
    throw error;
  }
};

export const createVendorCategoryAlias = async (vendorCategoryAliasData) => {
  try {
    const response = await axios.post('/categories-of-vendor-list/create-alias', vendorCategoryAliasData);
    return response.data;
  } catch (error) {
    console.error("Error creating vendor category alias:", error);
    throw error;
  }
};

export const getAllVendorCategories = async () => {
  try {
    const response = await axios.get('/categories-of-vendor-list');
    return response.data;
  } catch (error) {
    console.error("Error fetching vendor categories:", error);
    throw error;
  }
};

export const createCountry = async (countryData) => {
  try {
    const response = await axios.post('/countries', countryData);
    return response.data;
  } catch (error) {
    console.error("Error creating country:", error);
    throw error;
  }
};

export const createCountryAlias = async (countryAliasData) => {
  try {
    const response = await axios.post('/countries/create-alias', countryAliasData);
    return response.data;
  } catch (error) {
    console.error("Error creating country alias:", error);
    throw error;
  }
};

export const getAllCountries = async () => {
  try {
    const response = await axios.get('/countries');
    return response.data;
  } catch (error) {
    console.error("Error fetching countries:", error);
    throw error;
  }
};
export const createUnit = async (unitData) => {
  try {
    const response = await axios.post("/units", unitData);
    return response.data;
  } catch (error) {
    console.error("Error creating unit:", error);
    throw error;
  }
};

export const createUnitAlias = async (unitAliasData) => {
  try {
    const response = await axios.post("/units/create-alias", unitAliasData);
    return response.data;
  } catch (error) {
    console.error("Error creating unit alias:", error);
    throw error;
  }
};

export const getAllUnits = async () => {
  try {
    const response = await axios.get("/units");
    return response.data;
  } catch (error) {
    console.error("Error fetching units:", error);
    throw error;
  }
};
